//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import {getUrlparams} from '@/utils/util.js'

export default {
  name: "addReason",
  components: {
  },
  data() {
    return {
      showPicker:false,
      showPicker1:false,
      reason:'',
      subReason:'',
      color:'',
      number:'',
      purchaseId:'',
      type:'',
      columns1: ['一般','严重'],
      columns: [
        {
          id:'1',
          text: '面料疵点',
          children: [
            {
              id:'1',
              text: '面料的克重和手感与确认样不同',
            },
            {
              id:'2',
              text: '破洞',
            },
            {
              id:'3',
              text: '面料上出现的疵点，不同于确认样（如剪口、洞、污迹、\n' +
                '跳针、漏针、勾丝、起球、织法错误等）',
            },
            {
              id:'4',
              text: '面料印花、条纹、格子与要求不符',
            },
            {
              id:'5',
              text: '死印、横路',
            },
            {
              id:'6',
              text: '起球变型',
            },
            {
              id:'7',
              text: '不良异味',
            },
          ],
        },
        {
          id:'2',
          text: '色差',
          children: [
            {
              id:'1',
              text: '片与片之间有色差（看色差等级）',
            },
            {
              id:'2',
              text: '辅料与产品的色差',
            },
            {
              id:'3',
              text: '明显部位有印染的条纹与痕迹',
            },
            {
              id:'4',
              text: '同一订单明显缸差',
            }
          ],
        },
        {
          id:'3',
          text: '整理',
          children: [
            {
              id:'1',
              text: '斑点、脏污和油污',
            },
            {
              id:'2',
              text: '大于3mm的线毛',
            },
            {
              id:'3',
              text: '反面大于5mm的线毛不能超过3根',
            },
            {
              id:'4',
              text: '大面积污染',
            }
          ],
        },
        {
          id:'4',
          text: '绣花',
          children: [
            {
              id:'1',
              text: '尺寸或花型不对',
            },
            {
              id:'2',
              text: '线头未清剪干净',
            },
            {
              id:'3',
              text: '绣花尾部不良容易拉脱',
            },
            {
              id:'4',
              text: '绣花位置偏位超过7mm',
            },
            {
              id:'5',
              text: '线迹密度不对，造成外观严重不平整',
            }
          ],
        },
      ],
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm(value) {
      this.reason=value[0];
      this.subReason=value[1];
      // this.color = value;
      this.showPicker = false;
    },
    toEdit(){
      this.$router.push({name:'productCertificateEdit'})
    },
    onConfirm1(value){
      this.type = value;
      this.showPicker1 = false;
    },
    finish(){
      if(this.$route.params.type==1){
        this.$router.push({name:'createNoTest',params:{data:{reason:this.reason,subReason:this.subReason,number:this.number,type:this.type}}})
      }else{
        this.$router.push({name:'qualityOrderDetail'})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/addReason.vue